<template>
  <div class="col-md-10">
    <h4>Publicaciones</h4>
    <div class="card p-3">
      <div class="card-body">
        <a class="btn btn-outline-primary rounded-pill mb-2" href="/admin/news/create"
          ><i class="fal fa-plus"></i> Nuevo Post / Noticia</a
        >
        <div class="indeterminate-progress-bar mb-2" v-show="loading">
          <div class="indeterminate-progress-bar__progress"></div>
        </div>
        <div class="table-responsive">
          <table class="table-dash table" v-show="Object.keys(news).length">
            <thead>
              <tr>
                <th>ID</th>
                <th width="60%" style="min-width: 350px">Título</th>
                <th>Autor / Fecha</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in news.data" :key="item.id">
                <td class="text-center">{{ item.id }}</td>
                <td>
                  <span v-show="item.status == 'public'" class="badge badge-pill badge-primary me-2">{{
                    item.Estado
                  }}</span
                  ><span>{{ item.name }}</span>
                </td>
                <td>
                  {{ item.Autor }} <br />
                  <small class="text-muted">{{ item.PublishDate }}</small>
                </td>
                <td>
                  <a :href="'/admin/news/' + item.id + '/edit'" class="btn btn-outline-light"
                    ><i class="fa fa-edit"></i
                  ></a>
                  <button class="btn btn-outline-danger ms-1" type="button" @click="confirmDelete(item, index)">
                    <i class="fal fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination :data="news" @pagination-change-page="getData" />
        <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
          <div class="text-center">
            <div class="mb-2"><b>Confirma que desea eliminar este post?</b></div>
            <span>{{ sel.name }}</span>
            <div class="d-flex justify-content-center mt-3">
              <button class="btn btn-light rounded-pill" @click="cancel()">Cancelar</button>
              <button class="btn btn-danger rounded-pill ms-2" @click="destroy()">Confirmar</button>
            </div>
          </div>
        </vue-final-modal>
      </div>
    </div>
  </div>
</template>

<script>
import LaravelVuePagination from 'laravel-vue-pagination'
export default {
  name: 'NewsTable',
  props: {
    news: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Pagination: LaravelVuePagination,
  },
  data() {
    return {
      showModal: false,
      data: {},
      sel: {},
      selIndex: null,
    }
  },
  methods: {
    getData(page) {
      this.$emit('get-data', page)
    },
    confirmDelete(item, index) {
      this.sel = item
      this.selIndex = index
      this.showModal = true
    },
    cancel() {
      this.showModal = false
      this.sel = {}
      this.selIndex = null
    },
    destroy() {
      const self = this
      axios.delete('/admin/news/' + self.sel.id, {}).then((res) => {
        if (res.data.success) {
          // self.$message({ message: res.data.message, duration: 3000, type: 'success' })
          self.news.data.splice(self.selIndex, 1)
          self.news.total--
          self.cancel()
        }
      })
    },
  },
}
</script>
